import React, { useState, useEffect } from 'react';
import PageTitle from '../layout/PageTitle';
import Footer from '../layout/Footer';
import { Container, Row, Col, Card, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { formatISODateWithTimezone, getFromAPI, postToAPI, putToAPI } from '../../Utils/utils';
import { toast, ToastContainer } from "react-toastify";
import SettingsListData from "./settings-data.json";
import debounce from "lodash.debounce";
import eventEmitter from '../../Utils/eventEmitter';
// Icon
import Icon from '@mdi/react';
import { mdiArrowRightThin } from '@mdi/js';

export default function Settings() {
    const [settingsData] = useState(SettingsListData);
    const [modules, setModules] = useState([]);
    const [selectedRadio, setSelectedRadio] = useState(''); // State to track selected radio button
    const [checked, setChecked] = useState(); // State to manage the checkbox checked status
    const [consumableStockChecked, setConsumableStockChecked] = useState(false); // Use this state to control checkbox
    const [productVisibility, setProductVisibility] = useState(null); // New state for fetched value
    const [manageWeekend, setManageWeekend] = useState('true'); //
    const [alternateSaturdayOption, setAlternateSaturdayOption] = useState('');
    const isAdmin = Number(localStorage.getItem('admin'));
    const isStaffId = Number(localStorage.getItem('loggedInStaffId'));
    const [casualLeave, setCasualLeave] = useState('true');
    const [paidDays,setPaidDays] = useState('true')
    const [workinghours,setworkingHours] = useState('true')
    const [esiChecked,setesiChecked] = useState('false')
    const [pfChecked,setPfChecked] = useState('false')
    const [gratuityChecked,setGratuityChecked] = useState('false')
    const [ptChecked,setPtChecked] = useState('false')
    const [optionData, setOptionData] = useState({
        created_branch_id: 0,
        created_user_id: isStaffId,
        last_modified_user_id: 0,
        autoload: 1
    });

    // Fetch the initial option data
    const fetchOptionData = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=product_on_floor_in_store');
            setProductVisibility(response[0].value)
            if (response[0].value === "1") setSelectedRadio("in-store-check-radio");
            else if (response[0].value === "2") setSelectedRadio("on-floor-check-radio");
            else if (response[0].value === "0") setSelectedRadio("both-check-radio");
        } catch (error) {
            return null;
        }
    };
    // Add this new function to fetch alternate Saturday data
    const fetchAlternateSaturdayData = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=leave_alternate_saturday');
            if (response[0].value === "2") {
                setAlternateSaturdayOption("all");
            } else if (response[0].value === "1") {
                setAlternateSaturdayOption("second_and_fourth");
            } else if (response[0].value === "0") {
                setAlternateSaturdayOption("first_and_third");
            }
            else if (response[0].value === "3") {
                setAlternateSaturdayOption("no_saturday");
            }
        } catch (error) {
            return null;
        }
    };



    // Fetch initial data for consumable stock checkbox
    const fetchCheckedOption = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=product_consumable_stock');
            if (response[0]?.value === "1") {
                setConsumableStockChecked(true); // If the response value is "1", checkbox will be checked
            } else {
                setConsumableStockChecked(false); // If the response value is not "1", checkbox will be unchecked
            }
        } catch (error) {
            return null;
        }
    };

    const fetchWeekendOption = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=manage_weekend');

            // Set the `manageWeekend` state to the fetched value (e.g., "1" for Sunday, "2" for Monday, etc.)
            if (response[0] && response[0].value) {
                setManageWeekend(response[0].value);
            }
        } catch (error) {
            return null;
        }
    };

    const fetchCasualLeaveData = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=casual_leave');

            // Set the `manageWeekend` state to the fetched value (e.g., "1" for Sunday, "2" for Monday, etc.)
            if (response[0] && response[0].value) {
                setCasualLeave(response[0].value);
            }
        } catch (error) {
            return null;
        }
    };
    const fetchPaidDays = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=paid_days');

            // Set the `manageWeekend` state to the fetched value (e.g., "1" for Sunday, "2" for Monday, etc.)
            if (response[0] && response[0].value) {
                setPaidDays(response[0].value);
            }
        } catch (error) {
            return null;
        }
    };

    const fetchWorkingHours = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=working_hours');

            // Set the `manageWeekend` state to the fetched value (e.g., "1" for Sunday, "2" for Monday, etc.)
            if (response[0] && response[0].value) {
                setworkingHours(response[0].value);
            }
        } catch (error) {
            return null;
        }
    };

    const fetchESIOption = async() => {
        try{
            const response = await getFromAPI('FtsOptions/?name=esi_checked')
            if(response[0]?.value === "1"){
                setesiChecked(true)
            }else{
                setesiChecked(false)
            }
        }catch(error){
            return null;
        }
    };

    const fetchVpfOption = async () => {
        try{
            const response = await getFromAPI('FtsOptions/?name=vpf_checked')
            if(response[0]?.value === "1"){
                setPfChecked(true)
            }else{
                setPfChecked(false)
            }
        } catch(error){
            return null;
        }
    };
    const fetchGratuityCheckBox = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=gratuity_checkbox');
    
            if (response[0]?.value === "1") {
                setGratuityChecked(true);
            } else {
                setGratuityChecked(false);
            }
        } catch (error) {
            console.error('Error fetching gratuity checkbox state:', error);
        }
    };

    const fetchptCheckBox = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=pt');
    
            if (response[0]?.value === "1") {
                setPtChecked(true);
            } else {
                setPtChecked(false);
            }
        } catch (error) {
            console.error('Error fetching professional tax checkbox state:', error);
        }
    };

    useEffect(() => {
        fetchOptionData();
        fetchCheckedOption();
        fetchAlternateSaturdayData();
        fetchWeekendOption();
        fetchCasualLeaveData();
        fetchPaidDays();
        fetchWorkingHours();
        fetchVpfOption();
        fetchESIOption();
        fetchGratuityCheckBox();
        fetchptCheckBox();
    }, []);

    const fetchModules = async () => {
        try {
            const response = await getFromAPI('FtsModules/');
            setModules(response);
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        fetchModules();
    }, []);

    // Update module's isactive status in the backend
    const updateModule = async (moduleId, isActiveStatus) => {
        try {
            await putToAPI(`FtsModules/${moduleId}/`, { active: isActiveStatus });
        } catch (error) {
            return null;
        }
    };

    // Handle checkbox change for modules
    const onCheckboxChange = async (index) => {
        const updatedModules = [...modules];
        updatedModules[index].active = updatedModules[index].active === 1 ? 0 : 1;
        setModules(updatedModules);
    
        try {
            await updateModule(updatedModules[index].id, updatedModules[index].active);
            eventEmitter.emit('moduleUpdated');
        } catch (error) {
            console.error("Error updating module:", error);
        }
    };

    const handleEsiChecked = async (e) => {
        const isChecked = e.target.checked;
        setesiChecked(isChecked); // Ensure state update follows React conventions
        const name = 'esi_checked';
        const value = isChecked ?'1' : '0';
        // Prepare data for API request
        const data = {
            name: name,
            value: value,
            autoload: 1,
            created_branch_id: 0,  // Replace with actual branch ID if available
            created_user_id: isStaffId, // Replace with actual user ID if available
            created_date_time: new Date().toISOString(),
            last_modified_date_time: new Date().toISOString(),
            last_modified_user_id: 0 // Replace with actual user ID if available
        };
    
        try {
            await postToAPI('update_or_create_option/', data);
            toast.success('Option saved successfully'); // Removed redundant 'Success' argument
        } catch (error) {
            console.error('Error updating option:', error); // Log error for debugging
        }
    };
    
    const handlepfChecked = async(e) => {
        const isChecked = e.target.checked;
        setPfChecked(isChecked)

        const name = 'vpf_checked';
        const value = isChecked ?'1' : '0';

        const data = {
            name,
            value,
            autoload:1,
            created_branch_id: 0,  // Use actual branch ID if available
            created_user_id: isStaffId,    // Use actual user ID if available
            created_date_time: new Date().toISOString(),
            last_modified_date_time: new Date().toISOString(),
            last_modified_user_id: 0 // Use actual user ID if available
        };

        try{
            await postToAPI('update_or_create_option/',data);
            toast.success('Option Saved successfully', 'Success');
        } catch(error){
            return null;
        }
    };

    const handleGratuityChecked = async (e) => {
        const isChecked = e.target.checked;
        setGratuityChecked(isChecked); // Update state
    
        // Prepare data for API request
        const data = {
            name: 'gratuity_checkbox',
            value: isChecked ? '1' : '0',
            autoload: 1,
            created_branch_id: 0, // Replace with actual branch ID if available
            created_user_id: isStaffId, // Ensure isStaffId is properly defined
            created_date_time: new Date().toISOString(),
            last_modified_date_time: new Date().toISOString(),
            last_modified_user_id: 0 // Replace with actual user ID if available
        };
    
        try {
            const response = await postToAPI('update_or_create_option/', data);
            if (response) {
                toast.success('Option saved successfully'); // Fixed incorrect syntax
            } else {
                toast.error('Failed to save option');
            }
        } catch (error) {
            console.error('Error updating gratuity checkbox:', error);
            toast.error('Error updating option');
        }
    };

    const handleptChecked = async (e) => {
        const isChecked = e.target.checked;
        setPtChecked(isChecked); // Update state
    
        // Prepare data for API request
        const data = {
            name: 'pt',
            value: isChecked ? '1' : '0',
            autoload: 1,
            created_branch_id: 0, // Replace with actual branch ID if available
            created_user_id: isStaffId, // Ensure isStaffId is properly defined
            created_date_time: new Date().toISOString(),
            last_modified_date_time: new Date().toISOString(),
            last_modified_user_id: 0 // Replace with actual user ID if available
        };
    
        try {
            const response = await postToAPI('update_or_create_option/', data);
            if (response) {
                toast.success('Option saved successfully'); // Fixed incorrect syntax
            } else {
                toast.error('Failed to save option');
            }
        } catch (error) {
            console.error('Error updating gratuity checkbox:', error);
            toast.error('Error updating option');
        }
    };

    // Example of how the backend function could be called
    const updateOptionInBackend = async (data) => {
        try {
            // Ensuring value is a string before sending it to the backend
            const response = await postToAPI('update_or_create_option/', data);
            if(data.name == "manage_weekend")
            {   
                toast.success("Manage weekend saved successfully")
            }
            else if(data.name == "casual_leave")
            {
                toast.success("Casual leave saved successfully")
            }
            else if(data.name == "paid_days")
            {
                toast.success("Paid days saved successfully")
            }
            else if(data.name == "working_hours")
            {
                toast.success("Working hours saved successfully")
            }
            else{
            toast.success('Option Saved successfully', 'Success');
            }
        } catch (error) {
            return null;
        }
    };

    // Add this new handler for alternate Saturday radio changes
    const handleAlternateSaturdayChange = async (e) => {
        const selectedOption = e.target.id;
        setAlternateSaturdayOption(selectedOption);

        let value;
        if (selectedOption === 'all') value = '2';
        else if (selectedOption === 'second_and_fourth') value = '1';
        else if (selectedOption === 'first_and_third') value = '0';
        else if (selectedOption === 'no_saturday') value = '3';

        const currentDateTime = new Date();
        const data = {
            name: 'leave_alternate_saturday',
            value,
            autoload: 1,
            created_branch_id: optionData.created_branch_id,
            created_user_id: isStaffId,
            created_date_time: formatISODateWithTimezone(currentDateTime),
            last_modified_date_time: formatISODateWithTimezone(currentDateTime),
            last_modified_user_id: optionData.last_modified_user_id,
        };

        try {
            await updateOptionInBackend(data);
        } catch (error) {
            return null;
        }
    };

    const handlWeekendChange = async (e) => {
        const selectedOption = e.target.value; // Get the selected value
        setManageWeekend(selectedOption); // Update the state instantly

        // Prepare data for the backend
        const currentDateTime = new Date();
        const data = {
            name: 'manage_weekend', // Option name
            value: selectedOption, // Selected weekend day
            autoload: 1,
            created_branch_id: optionData.created_branch_id,
            created_user_id: isStaffId,
            created_date_time: formatISODateWithTimezone(currentDateTime),
            last_modified_date_time: formatISODateWithTimezone(currentDateTime),
            last_modified_user_id: optionData.last_modified_user_id,
        };

        try {
            await updateOptionInBackend(data); // Save to backend
        } catch (error) {
            toast.error('Failed to update weekend', 'Error');
        }
    };

    const handleCasualLeaveChange = (e) => {
        // Update casual leave state as user types (no backend call here)
        setCasualLeave(e.target.value);
    };

    const handleCasualLeaveKeyPress = async (e) => {
        // Only trigger the backend update when Enter key is pressed
        if (e.key === 'Enter') {
            const selectedCasualLeave = e.target.value;
            setCasualLeave(selectedCasualLeave); // Update state instantly
            if(selectedCasualLeave < 1) {
                toast.error('Casual leave cannot be less than 1', 'Error');
                return;
            }
            // Prepare data for the backend
            const currentDateTime = new Date();
            const data = {
                name: 'casual_leave',
                value: selectedCasualLeave,
                autoload: 1,
                created_branch_id: optionData?.created_branch_id,
                created_user_id: isStaffId,
                created_date_time: formatISODateWithTimezone(currentDateTime),
                last_modified_date_time: formatISODateWithTimezone(currentDateTime),
                last_modified_user_id: optionData?.last_modified_user_id,
            };

            try {
                // Save to backend
                await updateOptionInBackend(data);
            } catch (error) {
                // Handle error
                toast.error('Failed to update casual leave. Please try again.', 'Error');
            }
        }
    };

    const handlePaidDaysChange = (e) => {
        // Update casual leave state as user types (no backend call here)
        setPaidDays(e.target.value);
    };

    const handlePaidDaysKeyPress = async (e) => {
        // Only trigger the backend update when Enter key is pressed
        if (e.key === 'Enter') {
            const selectedPaidDays = e.target.value;
            setPaidDays(selectedPaidDays); // Update state instantly
            if(selectedPaidDays < 12) {
                toast.error('Paid Days cannot be less than 12', 'Error');
                return;
            }
            // Prepare data for the backend
            const currentDateTime = new Date();
            const data = {
                name: 'paid_days',
                value: selectedPaidDays,
                autoload: 1,
                created_branch_id: optionData?.created_branch_id,
                created_user_id: isStaffId,
                created_date_time: formatISODateWithTimezone(currentDateTime),
                last_modified_date_time: formatISODateWithTimezone(currentDateTime),
                last_modified_user_id: optionData?.last_modified_user_id,
            };

            try {
                // Save to backend
                await updateOptionInBackend(data);
            } catch (error) {
                // Handle error
                toast.error('Failed to update paid leave. Please try again.', 'Error');
            }
        }
    };

    const handleWoringHoursChange = (e) => {
        // Update casual leave state as user types (no backend call here)
        setworkingHours(e.target.value);
    };

    const handleWorkingHoursKeyPress = async (e) => {
        // Only trigger the backend update when Enter key is pressed
        if (e.key === 'Enter') {
            const selectedWorkingHours = e.target.value;
            setworkingHours(selectedWorkingHours); // Update state instantly
            if(selectedWorkingHours < 80) {
                toast.error('Paid Days cannot be less than 80', 'Error');
                return;
            }
            // Prepare data for the backend
            const currentDateTime = new Date();
            const data = {
                name: 'working_hours',
                value: selectedWorkingHours,
                autoload: 1,
                created_branch_id: optionData?.created_branch_id,
                created_user_id: isStaffId,
                created_date_time: formatISODateWithTimezone(currentDateTime),
                last_modified_date_time: formatISODateWithTimezone(currentDateTime),
                last_modified_user_id: optionData?.last_modified_user_id,
            };

            try {
                // Save to backend
                await updateOptionInBackend(data);
            } catch (error) {
                // Handle error
                toast.error('Failed to update paid leave. Please try again.', 'Error');
            }
        }
    };

    const handleRadioChange = async (e) => {
        const selectedRadioId = e.target.id;
        setSelectedRadio(selectedRadioId); // Update selected radio button state instantly

        // Prepare the data based on the selected radio button
        let name = 'product_on_floor_in_store';
        let value = productVisibility;

        if (selectedRadioId === 'on-floor-check-radio') value = '2';
        else if (selectedRadioId === 'in-store-check-radio') value = '1';
        else if (selectedRadioId === 'both-check-radio') value = '0';

        const currentDateTime = new Date();
        const data = {
            name,
            value,
            autoload: 1,
            created_branch_id: optionData.created_branch_id,
            created_user_id: isStaffId,
            created_date_time: formatISODateWithTimezone(currentDateTime),
            last_modified_date_time: formatISODateWithTimezone(currentDateTime),
            last_modified_user_id: optionData.last_modified_user_id,
        };

        // Update the backend with the new option data
        try {
            await updateOptionInBackend(data);
        } catch (error) {
            return null;
        }
    };

    // Handle checkbox change and update backend
    const handleCheckboxChange = async (e) => {
        const isChecked = e.target.checked;
        setConsumableStockChecked(isChecked); // Update checkbox state

        const name = 'product_consumable_stock';
        const value = isChecked ? '1' : '0'; // Set value based on checkbox state

        // Prepare data to update in the backend
        const data = {
            name,
            value,
            autoload: 1,
            created_branch_id: 0,  // Use actual branch ID if available
            created_user_id: isStaffId,    // Use actual user ID if available
            created_date_time: new Date().toISOString(),
            last_modified_date_time: new Date().toISOString(),
            last_modified_user_id: 0 // Use actual user ID if available
        };

        // Send the updated data to the backend
        try {
            await postToAPI('update_or_create_option/', data);
            toast.success('Option Saved successfully', 'Success');
        } catch (error) {
            return null;
        }
    };

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col xl={6}>
                                <Card>
                                    <Card.Body className='pb-0'>
                                        <Card.Title>Account & Support Settings</Card.Title>
                                        <Row>
                                            {settingsData.supportSettingsLink.map((linkname, i) =>
                                                <Col md={6} key={i}>
                                                    <Card className='border shadow-none'>
                                                        <Card.Body>
                                                            <Link to={linkname.cardLink} className='d-flex justify-content-between align-items-center'>
                                                                <h5 className='fw-normal mb-0 me-3'>{linkname.id}.{linkname.settingLinkName}</h5>
                                                                <Icon path={mdiArrowRightThin} className='icon-size-30 text-dark' />
                                                            </Link>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            )}
                                        </Row>
                                    </Card.Body>
                                </Card>

                                <Card>
                                    <Card.Body className='pb-0'>
                                        <Card.Title>Masters</Card.Title>
                                        <Row>
                                            {settingsData.mastersLink.map((linkname, i) =>
                                                <Col md={6} key={i}>
                                                    <Card className='border shadow-none'>
                                                        <Card.Body>
                                                            <Link to={linkname.cardLink} className='d-flex justify-content-between align-items-center'>
                                                                <h5 className='fw-normal mb-0 me-3'>{linkname.id}.{linkname.settingLinkName}</h5>
                                                                <Icon path={mdiArrowRightThin} className='icon-size-30 text-dark' />
                                                            </Link>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            )}
                                        </Row>
                                    </Card.Body>
                                </Card>

                                <Card>
                                    <Card.Body className='pb-0'>
                                        <Card.Title>Privacy & Security Settings</Card.Title>
                                        <Row>
                                            {settingsData.securitySettingsLink.map((linkname, i) =>
                                                <Col md={6} key={i}>
                                                    <Card className='border shadow-none'>
                                                        <Card.Body>
                                                            <Link to={linkname.cardLink} className='d-flex justify-content-between align-items-center'>
                                                                <h5 className='fw-normal mb-0 me-3'>{linkname.id}.{linkname.settingLinkName}</h5>
                                                                <Icon path={mdiArrowRightThin} className='icon-size-30 text-dark' />
                                                            </Link>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            )}
                                        </Row>
                                    </Card.Body>
                                </Card>
                                <Card>
                                    <Card.Body className='pb-0'>
                                        <Card.Title>Manage Earning Settings</Card.Title>
                                        <Form>
                                            {['checkbox'].map((type) => (
                                                <div key={`default-${type}`} className="mb-3">
                                                    <Form.Check
                                                        type={type}
                                                        id={`manage-earning-${type}`}
                                                        label={`Customise Provider Earning`}
                                                    />
                                                </div>
                                            ))}
                                        </Form>
                                    </Card.Body>
                                </Card>

                            </Col>

                            <Col xl={6}>
                                <Card>
                                    <Card.Body className='pb-0'>
                                        <Card.Title>Product & Service Helper Masters</Card.Title>
                                        <Row>
                                            {settingsData.helperMastersLink.map((linkname, i) =>
                                                <Col md={6} key={i}>
                                                    <Card className='border shadow-none'>
                                                        <Card.Body>
                                                            <Link to={linkname.cardLink} className='d-flex justify-content-between align-items-center'>
                                                                <h5 className='fw-normal mb-0 me-3'>{linkname.id}.{linkname.settingLinkName}</h5>
                                                                <Icon path={mdiArrowRightThin} className='icon-size-30 text-dark' />
                                                            </Link>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            )}
                                        </Row>
                                    </Card.Body>
                                </Card>

                                <Card>
                                    <Card.Body className='pb-0'>
                                        <Card.Title>GST Settings</Card.Title>
                                        <Row>
                                            {settingsData.gstSettingsLink.map((linkname, i) =>
                                                <Col md={6} key={i}>
                                                    <Card className='border shadow-none'>
                                                        <Card.Body>
                                                            <Link to={linkname.cardLink} className='d-flex justify-content-between align-items-center'>
                                                                <h5 className='fw-normal mb-0 me-3'>{linkname.id}.{linkname.settingLinkName}</h5>
                                                                <Icon path={mdiArrowRightThin} className='icon-size-30 text-dark' />
                                                            </Link>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            )}
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                            {isAdmin === 1 && (
                                <Col md={12}>
                                    <Card>
                                        <Card.Body>
                                            <Card.Title>Leave Settings</Card.Title>
                                            <Row>
                                                {settingsData.leaveSettingsLink.map((linkname, i) => (
                                                    <Col md={6} key={i}>
                                                        <Card className='border shadow-none'>
                                                            <Card.Body>
                                                                <Link to={linkname.cardLink} className='d-flex justify-content-between align-items-center'>
                                                                    <h5 className='fw-normal mb-0 me-3'>
                                                                        {linkname.id}. {linkname.settingLinkName}
                                                                    </h5>
                                                                    <Icon path={mdiArrowRightThin} className='icon-size-30 text-dark' />
                                                                </Link>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                ))}
                                            </Row>

                                            {/* Manage Alternate Saturdays */}
                                            <Row>
                                                <Col lg={6}>
                                                    <Card.Title className="mt-4">Manage Alternate Saturdays</Card.Title>
                                                    <Form>
                                                        <ul className='list-inline mb-0'>
                                                            <li className='list-inline-item me-3'>
                                                                <Form.Check
                                                                    type="radio"
                                                                    id="no_saturday"
                                                                    name="alternate-saturday"
                                                                    label="No Leave on Saturdays"
                                                                    checked={alternateSaturdayOption === "no_saturday"}
                                                                    onChange={handleAlternateSaturdayChange}
                                                                />
                                                            </li>
                                                            <li className='list-inline-item me-3'>
                                                                <Form.Check
                                                                    type="radio"
                                                                    id="all"
                                                                    name="alternate-saturday"
                                                                    label="All Saturdays"
                                                                    checked={alternateSaturdayOption === "all"}
                                                                    onChange={handleAlternateSaturdayChange}
                                                                />
                                                            </li>
                                                            <li className='list-inline-item me-3'>
                                                                <Form.Check
                                                                    type="radio"
                                                                    id="first_and_third"
                                                                    name="alternate-saturday"
                                                                    label="1st & 3rd Saturday"
                                                                    checked={alternateSaturdayOption === "first_and_third"}
                                                                    onChange={handleAlternateSaturdayChange}
                                                                />
                                                            </li>
                                                            <li className='list-inline-item'>
                                                                <Form.Check
                                                                    type="radio"
                                                                    id="second_and_fourth"
                                                                    name="alternate-saturday"
                                                                    label="2nd & 4th Saturday"
                                                                    checked={alternateSaturdayOption === "second_and_fourth"}
                                                                    onChange={handleAlternateSaturdayChange}
                                                                />
                                                            </li>
                                                        </ul>
                                                    </Form>
                                                    <Form.Group className='mt-3'>
                                                        <Card.Title className="mt-4">Casual Leave</Card.Title>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="Enter casual leave and press enter"
                                                            id="casual_leave"
                                                            name="casual_leave"
                                                            value={casualLeave}
                                                            size='sm-3'
                                                            onChange={handleCasualLeaveChange}
                                                            onKeyPress={handleCasualLeaveKeyPress}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={6}>
                                                    {/* Manage Weekend */}
                                                    <Card.Title className="mt-4">Manage Weekend</Card.Title>
                                                    <Form.Group controlId="manage_weekend" className="custom-dropdown">
                                                        <Form.Control
                                                            as="select"
                                                            name="manage_weekend"
                                                            value={manageWeekend}
                                                            onChange={handlWeekendChange}
                                                        >
                                                            <option value="0">Sunday</option>
                                                            <option value="1">Monday</option>
                                                            <option value="2">Tuesday</option>
                                                            <option value="3">Wednesday</option>
                                                            <option value="4">Thursday</option>
                                                            <option value="5">Friday</option>
                                                            <option value="6">Saturday</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg = {6}>
                                                <Form.Group className='mt-3'>
                                                        <Card.Title className="mt-4">Working Hours</Card.Title>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="Enter working hours and press enter"
                                                            id="working_hours"
                                                            name="working_hours"
                                                            value={workinghours}
                                                            size='sm-3'
                                                            onChange={handleWoringHoursChange}
                                                            onKeyPress={handleWorkingHoursKeyPress}
                                                        />
                                                    </Form.Group>   
                                                </Col>
                                                <Col lg = {6}>
                                                <Form.Group className='mt-3'>
                                                        <Card.Title className="mt-4">Paid Days</Card.Title>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="Enter Paid days and press enter"
                                                            id="paid_days"
                                                            name="paid_days"
                                                            value={paidDays}
                                                            size='sm-3'
                                                            onChange={handlePaidDaysChange}
                                                            onKeyPress={handlePaidDaysKeyPress}
                                                        />
                                                    </Form.Group>   
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                        <Col>
                        <Card>
                        <Card.Body className='pb-0'>
                              {/* Payroll Setting Section */}
                             <Card.Title className='mt-4'>Payroll Setting</Card.Title>
                                <Row>
                                    <Col md={3}>
                                        <Form.Check 
                                            type="checkbox"
                                            label="ESI"
                                            id="esiCheckbox"
                                            checked = {esiChecked}
                                            onChange = {handleEsiChecked}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Check 
                                            type="checkbox"
                                            label="PF"
                                            id="pfCheckbox"
                                            checked = {pfChecked}
                                            onChange = {handlepfChecked}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Check 
                                            type="checkBox"
                                            label="Gratuity"
                                            id="gratuityCheckbox"
                                            checked = {gratuityChecked}
                                            onChange = {handleGratuityChecked}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Check 
                                            type="checkBox"
                                            label="pt"
                                            id="pt"
                                            checked = {ptChecked}
                                            onChange = {handleptChecked}
                                        />
                                    </Col>
                                </Row>
                                </Card.Body>
                           </Card>
                        </Col>

                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body className='pb-0'>
                                        <Card.Title>Modules</Card.Title>
                                        <Form>
                                            <Row sm={3} md={3} lg={4} xl={5} xxl={6} className='row-cols-2'>
                                                {modules.map((data, i) =>
                                                    <Col key={i}>
                                                        {['checkbox'].map((type) => (
                                                            <div key={`default-${type}`} className="mb-3">
                                                                <Form.Check
                                                                    type={type}
                                                                    id={`modules-${data.id}`}
                                                                    label={data.module_name}
                                                                    checked={data.active === 1}
                                                                    onChange={() => onCheckboxChange(i)}
                                                                />
                                                            </div>
                                                        ))}
                                                    </Col>
                                                )}
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col xl={7} xxl={8}>
                                <Card>
                                    <Card.Body className='pb-0'>
                                        <Card.Title>Invoice</Card.Title>

                                        <Form>
                                            <Row>
                                                <Col md={6} xxl={4}>
                                                    <div className="mb-3 custom-form-input">
                                                        <Form.Label>Set Default Invoice Type</Form.Label>
                                                        <Form.Select name='setDefaultInvoiceType' id='setDefaultInvoiceType'>
                                                            <option>Service</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                        </Form.Select>
                                                    </div>
                                                </Col>
                                                <Col md={6} xxl={4}>
                                                    <div className="mb-3 custom-form-input">
                                                        <Form.Label>Set Default Invoice Payment Mode</Form.Label>
                                                        <Form.Select name='setDefaultInvoicePaymentMode' id='setDefaultInvoicePaymentMode'>
                                                            <option>Cash</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                        </Form.Select>
                                                    </div>
                                                </Col>
                                                <Col md={6} xxl={4}>
                                                    <div className="mb-3 custom-form-input">
                                                        <Form.Label>Set Default Provider Of Invoice</Form.Label>
                                                        <Form.Select name='setDefaultProviderOfInvoice' id='setDefaultProviderOfInvoice'>
                                                            <option>Select Provider</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                        </Form.Select>
                                                    </div>
                                                </Col>
                                                <Col md={6} xxl={4}>
                                                    <div className="mb-3 custom-form-input">
                                                        <Form.Label>Set Default Customer Of Invoice</Form.Label>
                                                        <Form.Select name='setDefaultCustomerOfInvoice' id='setDefaultCustomerOfInvoice'>
                                                            <option>NFS Customer, 9825596868</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                        </Form.Select>
                                                    </div>
                                                </Col>
                                                <Col md={6} xxl={4}>
                                                    <div className="mb-3 custom-form-input">
                                                        <Form.Label>Thank You Message</Form.Label>
                                                        <Form.Select name='thankYouMessage' id='thankYouMessage'>
                                                            <option>NO</option>
                                                            <option value="1">Yes</option>
                                                        </Form.Select>
                                                    </div>
                                                </Col>
                                                <Col md={6} xxl={4}>
                                                    <div className="mb-3 custom-form-input">
                                                        <Form.Label>Allow Negative Stock Of Invoice</Form.Label>
                                                        <Form.Select name='allowNegativeStockOfInvoice' id='allowNegativeStockOfInvoice'>
                                                            <option>Yes</option>
                                                            <option value="1">No</option>
                                                        </Form.Select>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xl={5} xxl={4}>
                                <Card>
                                    <Card.Body className='pb-0'>
                                        <Card.Title>Products</Card.Title>
                                        <Form>
                                            <ul className='list-inline mb-0'>
                                                <li className='list-inline-item me-5'>
                                                    {['radio'].map((type) => (
                                                        <div key={`default-${type}`} className="mb-3">
                                                            <Form.Check
                                                                type={type}
                                                                id={`on-floor-check-${type}`}
                                                                name="products-radio-check"
                                                                label={`On Floor`}
                                                                checked={selectedRadio === "on-floor-check-radio"}
                                                                onChange={handleRadioChange} // Handle radio button change
                                                            />
                                                        </div>
                                                    ))}
                                                </li>
                                                <li className='list-inline-item me-5'>
                                                    {['radio'].map((type) => (
                                                        <div key={`default-${type}`} className="mb-3">
                                                            <Form.Check
                                                                type={type}
                                                                id={`in-store-check-${type}`}
                                                                name="products-radio-check"
                                                                label={`In Store`}
                                                                checked={selectedRadio === "in-store-check-radio"}
                                                                onChange={handleRadioChange} // Handle radio button change

                                                            />
                                                        </div>
                                                    ))}
                                                </li>
                                                <li className='list-inline-item'>
                                                    {['radio'].map((type) => (
                                                        <div key={`default-${type}`} className="mb-3">
                                                            <Form.Check
                                                                type={type}
                                                                id={`both-check-${type}`}
                                                                name="products-radio-check"
                                                                label={`Both`}
                                                                checked={selectedRadio === "both-check-radio"}
                                                                onChange={handleRadioChange} // Handle radio button change
                                                            />
                                                        </div>
                                                    ))}
                                                </li>
                                            </ul>

                                            <ul className='list-inline mb-0'>
                                                <li className='list-inline-item me-5'>
                                                    {['checkbox'].map((type) => (
                                                        <div key={`default-${type}`} className="mb-3">
                                                            <Form.Check
                                                                type={type}
                                                                id={`detail-in-product-Unchecked-${type}`}
                                                                label={`Show Weight Detail in Product`}
                                                            />
                                                        </div>
                                                    ))}
                                                </li>
                                                <li className='list-inline-item'>
                                                    {['checkbox'].map((type) => (
                                                        <div key={`default-${type}`} className="mb-3">
                                                            <Form.Check
                                                                type={type}
                                                                id={`consumable-stock-Unchecked-${type}`}
                                                                label={`Consumable Stock`}
                                                                checked={consumableStockChecked} // Dynamically set the checked value based on state
                                                                onChange={handleCheckboxChange} // Handle checkbox change
                                                            />
                                                        </div>
                                                    ))}
                                                </li>
                                            </ul>
                                        </Form>

                                        <Card.Title>Transfer Order</Card.Title>
                                        <Form>
                                            <ul className='list-inline mb-0'>
                                                <li className='list-inline-item me-5'>
                                                    {['checkbox'].map((type) => (
                                                        <div key={`default-${type}`} className="mb-3">
                                                            <Form.Check
                                                                type={type}
                                                                id={`detail-in-product1-Unchecked-${type}`}
                                                                label={`Show Weight Detail in Product`}
                                                            />
                                                        </div>
                                                    ))}
                                                </li>
                                                <li className='list-inline-item'>
                                                    {['checkbox'].map((type) => (
                                                        <div key={`default-${type}`} className="mb-3">
                                                            <Form.Check
                                                                type={type}
                                                                id={`consumable-stock-Unchecked1-${type}`}
                                                                label={`Consumable Stock`}
                                                            />
                                                        </div>
                                                    ))}
                                                </li>
                                            </ul>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body className='pb-0'>
                                        <Card.Title>Accounting</Card.Title>
                                        <Form>
                                            <Row>
                                                <Col md={4}>
                                                    <div className="mb-3 custom-form-input">
                                                        <Form.Label>Ledger Options</Form.Label>
                                                        <Form.Select name='ledgerOptions' id='ledgerOptions'>
                                                            <option>No</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                        </Form.Select>
                                                    </div>
                                                </Col>
                                                <Col sm={6} md={4}>
                                                    <div className="mb-3 custom-form-input">
                                                        <Form.Label>Show Category Option</Form.Label>
                                                        <Form.Select name='showCategoryOption' id='showCategoryOption'>
                                                            <option>No</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                        </Form.Select>
                                                    </div>
                                                </Col>
                                                <Col sm={6} md={4}>
                                                    <div className="mb-3 custom-form-input">
                                                        <Form.Label>Show Payment Type Option</Form.Label>
                                                        <Form.Select name='showPaymentTypeOption' id='showPaymentTypeOption'>
                                                            <option>No</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                        </Form.Select>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
